import { render, staticRenderFns } from "./NoveltyFkuSection.vue?vue&type=template&id=1d54cba2&scoped=true&"
import script from "./NoveltyFkuSection.vue?vue&type=script&lang=ts&"
export * from "./NoveltyFkuSection.vue?vue&type=script&lang=ts&"
import style0 from "./NoveltyFkuSection.vue?vue&type=style&index=0&id=1d54cba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54cba2",
  null
  
)

export default component.exports